import type { LoginAction } from '@shared/api/contracts/security';

const MEMORY_CHALLENGE_ACTIONS: LoginAction[] = ['confirm_otp', 'register_otp', 'confirm_device'];

export function isMemoryChallengeAction(action: string | undefined): action is LoginAction {
  return MEMORY_CHALLENGE_ACTIONS.some((item) => item === action);
}

export function parseLoginAction(action: string | undefined): LoginAction | undefined {
  if (
    action === 'confirm_email' ||
    action === 'confirm_otp' ||
    action === 'register_otp' ||
    action === 'confirm_device' ||
    action === 'login_success'
  ) {
    return action;
  }
  return undefined;
}
